import * as React from 'react';
import { useEffect, useState } from 'react';
import { Alert, Button, Card, CardText, CardTitle, Col, FormFeedback, FormGroup, Input, Label, Row, Toast, ToastBody, ToastHeader } from 'reactstrap';
import Swal from 'sweetalert2';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Afr, getSelectedAfr } from '../../redux/AfrSlice';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { AfrEvents, DiscrepancyEvent, EmailEventInput, getDiscrepancyEvents, getSelectedEvents, postDiscrepancy } from '../../redux/EventsSlice';
import dateHelper from '../../utils/dateHelper';
import JoditEditor from 'jodit-react';



const WYSIWYGEditor = (props: { content: string, setContent: React.Dispatch<React.SetStateAction<string>>, readOnly: boolean }) => {

	const editorRef = React.useRef(null);
	

	const options = ['bold', 'italic', '|', 'ul', 'ol', '|', 'font', 'fontsize', '|', 'outdent', 'indent', 'align', '|', 'hr', '|', 'fullsize', 'brush', '|', 'table', 'link', '|', 'undo', 'redo',];

	const config = {

		readonly: props.readOnly
	}
	

	return (
		<JoditEditor
			ref={editorRef}
			value={props.content || ''}
			config={config}
			onBlur={newContent => props.setContent(newContent)} // preferred to use only this option to update the content for performance reasons
			onChange={newContent => { }}
		/>
	);

}

export default WYSIWYGEditor;